import React from "react";
import { Box, Chip, Stack, Typography } from "@mui/material";
import { formatAmount } from "../../../../utils/hooks/dataHandler";
import SourceRowName from "../components/SourceRowName";

export default function RowInfoPanel({ row, section, editMode }) {
  if (!row) return null;

  return (
    <Box sx={{ py: 0.5 }}>
      <Stack
        direction='row'
        alignItems='center'
        spacing={1}
        useFlexGap
        flexWrap='wrap'
      >
        <SourceRowName
          name={row.name}
          variant='subtitle1'
          sx={{ lineHeight: 1.3 }}
        />
        {section ? (
          <Chip label={section} size='small' variant='outlined' />
        ) : null}
      </Stack>

      {row.amount ? (
        <Typography
          variant='body2'
          color='text.secondary'
          component='span'
          sx={{
            fontFamily: "monospace", // 等宽字体让数字对齐更美观
            fontWeight: 500,
            color: "text.primary",
          }}
        >
          Amount: {formatAmount(row.amount)}
        </Typography>
      ) : null}

      {row.taxAdjustment ? (
        <Typography
          variant='caption'
          color='text.secondary'
          component='p'
          sx={{ m: 0, mt: 0.25, lineHeight: 1.4 }}
        >
          {row.taxAdjustment}
        </Typography>
      ) : null}

      {editMode && row.schedule ? (
        <Typography
          variant='caption'
          color='primary'
          component='p'
          sx={{ m: 0, mt: 0.25, lineHeight: 1.4 }}
        >
          {row.schedule.scheduleTitle} (No. {row.schedule.scheduleNo})
        </Typography>
      ) : null}
    </Box>
  );
}
